import type { ReactNode } from 'react'

import { Brand } from '@/components/layout/Brand'
import { ThemeToggle } from '@/components/layout/ThemeToggle'
import { isDarkMode, useThemeStore } from '@/stores/themeStore'

interface AuthLayoutProps {
  title: string
  subtitle: string
  children: ReactNode
  footer?: ReactNode
}

export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  // A tela de login segue o tema do app (padrão claro), como todas as outras.
  const dark = isDarkMode(useThemeStore((state) => state.mode))

  return (
    <div className="relative grid min-h-dvh place-items-center bg-gradient-to-b from-[#e9eef5] to-[#f6f8fc] p-4 dark:from-[#0a2440] dark:via-[#0b1b2e] dark:to-[#04121f]">
      <div className="absolute right-3 top-3">
        <ThemeToggle />
      </div>

      <div className="w-full max-w-sm">
        <div className="pc-animate-modal overflow-hidden rounded-2xl border border-line bg-surface p-6 text-fg shadow-2xl sm:p-7 dark:bg-gradient-to-b dark:from-[#0b2038] dark:to-[#08192b] dark:ring-1 dark:ring-white/5">
          <div className="mb-6 flex justify-center">
            <Brand surface={dark ? 'dark' : 'light'} size="lg" />
          </div>

          <div className="mb-5 text-center">
            <h1 className="text-xl font-semibold text-fg">{title}</h1>
            <p className="mt-1 text-sm text-fg-muted">{subtitle}</p>
          </div>

          {children}
        </div>

        {footer && <div className="mt-4 text-center text-sm text-fg-muted">{footer}</div>}
      </div>
    </div>
  )
}
